// extracted by mini-css-extract-plugin
export var header = "_ua-1";
export var maskBottom = "_ua-6";
export var maskMiddle = "_ua-7";
export var maskTop = "_ua-5";
export var root = "_ua-0";
export var scrollDownButton = "_ua-3";
export var scrollDownButtonHidden = "_ua-4";
export var viewport = "_ua-2";